import {
  INICIALITZAR,
  OBTENIR_OBSERVADORS,
  OBTENIR_OBSERVADORS_LLISTAT,
  OBTENIR_OBSERVADOR_ID,
  OBTENIR_DADES_OBSERVADOR,
  ESBORRAR_OBSERVADOR_SELECCIONAT,
  OBTENIR_OBSERVADORS_ESPECIES
} from "../../actions/actionTypes";

const ESTAT_INICIAL = {
  observadors: {},
  rols: {},
  llistat: [],
  idObservadorSeleccionat: null,
  observadorSeleccionat: {},
  observadorsEspecies: []
};

const observadorsReducer = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
      return ESTAT_INICIAL;

    case `${OBTENIR_OBSERVADORS}_EN_CURS`:
    case `${OBTENIR_OBSERVADORS_ESPECIES}_EN_CURS`:
    case `${OBTENIR_DADES_OBSERVADOR}_EN_CURS`:
    case `${OBTENIR_OBSERVADORS_LLISTAT}_EN_CURS`:
      return {
        ...state
      };

    case `${OBTENIR_OBSERVADORS}_SUCCESS`:
      return {
        ...state,
        observadors: action.payload,
        rols: action.payload
      };

    case `${OBTENIR_OBSERVADORS}_ERROR`:
    case `${OBTENIR_OBSERVADORS_ESPECIES}_ERROR`:
    case `${OBTENIR_OBSERVADORS_LLISTAT}_ERROR`:
    case `${OBTENIR_DADES_OBSERVADOR}_ERROR`:
      return {
        ...state,
        error: action.error
      };

    case `${OBTENIR_OBSERVADORS_ESPECIES}_SUCCESS`:
      return {
        ...state,
        observadorsEspecies: action.payload.observadorsEspecies
      };

    case `${OBTENIR_OBSERVADORS_LLISTAT}_SUCCESS`:
      return {
        ...state,
        llistat: action.payload.observadors,
        rols: action.payload.rols
      };

    case `${OBTENIR_DADES_OBSERVADOR}_SUCCESS`:
      return {
        ...state,
        observadorSeleccionat: action.payload
      };

    case OBTENIR_OBSERVADOR_ID:
      return {
        ...state,
        idObservadorSeleccionat: action.payload
      };

    case ESBORRAR_OBSERVADOR_SELECCIONAT:
      return {
        ...state,
        idObservadorSeleccionat: null,
        observadorSeleccionat: {}
      };

    default:
      return state;
  }
};

export default observadorsReducer;

const getObservadors = state => state.observadors;
const esObservadorActiu = observador => observador.dataBaixa === null;
const esObservadorInactiu = observador => !esObservadorActiu(observador);
const getObservadorsPerEstat = (state, estatObservador) => {
  const observadors = getObservadors(state);
  if (!observadors) {
    return null;
  }

  var observadorsPerEstat = {};
  Object.keys(observadors).forEach(idObservador => {
    const observador = observadors[idObservador];
    if (estatObservador(observador)) {
      observadorsPerEstat[idObservador] = observador;
    }
  });

  return observadorsPerEstat;
};

export const getObservadorsAsArray = state => {
  const observadorsIndexatsPerId = getObservadors(state);
  return observadorsIndexatsPerId
    ? Object.keys(observadorsIndexatsPerId).map(idObservador => ({
        ...observadorsIndexatsPerId[idObservador],
        id: parseInt(idObservador)
      }))
    : [];
};

export const getObservadorPerId = state => {
  const observadorsLlistat = state.observadors ? state.observadors : {};
  const observadorId = state.idObservadorSeleccionat;
  return observadorsLlistat[observadorId];
};

export const getDadesObservador = state => {
  const observadorId = state.idObservadorSeleccionat;
  return state.observadorSeleccionat[observadorId];
};

export const getObservadorsActius = state => {
  return getObservadorsPerEstat(state, esObservadorActiu);
};

export const getObservadorsInactius = state => {
  return getObservadorsPerEstat(state, esObservadorInactiu);
};

export const getObservadorsUsuari = state => {
  return state.llistat;
};

export const getObservadorsEspecies = state => {
  return state.observadorsEspecies;
};

export const getRolsUsuari = state => {
  return state.rols;
};

export const getPeticioObservadorsError = state => state.error;

export const getIdObservador = state => {
  return state.idObservadorSeleccionat;
};

export const getIndretsIndividusFenofases = state => {
  const idObservador = state.dades.idObservadorSeleccionat;
  return idObservador
    ? state.dades.observadorSeleccionat[idObservador].indretsIndividusFenofases
    : [];
};
